export default "__VITE_ASSET__C1o25vzS__"